import { Directive, HostListener, inject, input } from '@angular/core';
import { CaseTrackingService } from '../../service/case-tracking.service';
import { AccessType } from '../../types';

@Directive({
  selector: '[appTrackReviewActivity]',
  standalone: true,
})
export class TrackReviewActivityDirective {
  private caseTrackingService = inject(CaseTrackingService);

  public appTrackReviewActivity = input.required<string>();
  public appTrackReviewActivityValue = input.required<string>();
  public appTrackReviewActivityAccessType = input.required<AccessType>();

  @HostListener('click')
  click() {
    this.caseTrackingService
      .trackActivity(this.appTrackReviewActivity(), this.appTrackReviewActivityAccessType(), this.appTrackReviewActivityValue())
      .subscribe();
  }
}
